import { env } from '@/utils/constants/env';
import { axiosInstance } from '@/utils/lib/axios';
import { useQuery } from '@tanstack/react-query';

export interface BPMNFile {
    id: number;
    name: string;
    slug: string;
    file_type: string;
    drive_type: string;
    created_at: string;
    updated_at: string;
}

export const DriveOrgMappingService = {
    /**
     * Fetch all BPMN files that reference a specific org chart node (role)
     */
    useGetFilesByOrgChartNode: (tenantId: number | string, nodeId: number | string, enabled = true) => {
        return useQuery<BPMNFile[]>({
            queryKey: ['bpmn-files-by-node', { tenantId, nodeId }],
            queryFn: async () => {
                if (!tenantId || !nodeId) throw new Error('Missing tenantId or nodeId');

                const { data } = await axiosInstance.get(
                    `${env.apiTasklistBaseUrl}/api/v1/probis/drive/${tenantId}/role/${nodeId}/files`,
                );

                return data.data || [];
            },
            enabled: enabled && !!tenantId && !!nodeId,
        });
    },

    /**
     * Fetch all BPMN files that use a specific organization
     */
    useGetFilesByOrganization: (tenantId: number | string, orgId: number | string, enabled = true) => {
        return useQuery<BPMNFile[]>({
            queryKey: ['bpmn-files-by-org', { tenantId, orgId }],
            queryFn: async () => {
                if (!tenantId || !orgId) throw new Error('Missing tenantId or orgId');

                const { data } = await axiosInstance.get(
                    `${env.apiTasklistBaseUrl}/api/v1/probis/drive/${tenantId}/organization/${orgId}/files`,
                );

                return data.data || [];
            },
            enabled: enabled && !!tenantId && !!orgId,
        });
    },
};
